import { AttachmentFullViewState } from 'owa-attachment-full-data';
import getAttachmentFullViewStateById from 'owa-attachment-well-data/lib/utils/getAttachmentFullViewStateById';
import { ClientAttachmentId } from 'owa-client-ids';
import { SxSItemReadingPaneState } from '../store/schema/SxSReadingPaneState';

export default function tryGetAttachmentFullViewStateByIdForItemView(
    attachmentId: ClientAttachmentId,
    sxsItemReadingPaneState: SxSItemReadingPaneState
): AttachmentFullViewState {
    if (!sxsItemReadingPaneState) {
        return null;
    }

    if (sxsItemReadingPaneState.itemReadingPaneViewState?.itemViewState) {
        const attachmentWellViewState =
            sxsItemReadingPaneState.itemReadingPaneViewState.itemViewState.attachmentWell;
        if (!!attachmentWellViewState) {
            const attachmentFullViewState = getAttachmentFullViewStateById(
                attachmentWellViewState,
                attachmentId
            );
            if (!!attachmentFullViewState) {
                return attachmentFullViewState;
            }
        }
    }

    return null;
}
